module.exports = __webpack_public_path__ + "assets/img/broadcastsystem.7df113fb.png";